export default __webpack_public_path__ + "static/media/stands_ind_zeraus.b73cabb4.jpg";